var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.65 18.65 24 12 24C5.34996 24 0 18.65 0 12C0 5.34996 5.34996 0 12 0C18.65 0 24 5.34996 24 12ZM15.0833 9.29167C15.4167 9.125 15.7917 9.125 16.0833 9.29167L19.4583 11.25C19.7917 11.4583 19.9583 11.7917 19.9583 12.125V16.0833C19.9583 16.4583 19.75 16.7917 19.4583 16.9583L16.0833 18.9167C15.75 19.0833 15.375 19.0833 15.0833 18.9167L11.7083 16.9583C11.375 16.75 11.2083 16.4167 11.2083 16.0833V14.7083L12.7917 13.7917V15.125C12.7917 15.5 13 15.8333 13.2917 16L15.0833 17.0417C15.4167 17.2083 15.7917 17.2083 16.0833 17.0417L17.8333 16C18.1667 15.7917 18.3333 15.4583 18.3333 15.125V13.0417C18.3333 12.6667 18.125 12.3333 17.8333 12.1667L16.0417 11.125C15.7083 10.9583 15.3333 10.9583 15.0417 11.125L12.75 12.4583L11.1667 13.375L8.875 14.7083C8.54167 14.875 8.16667 14.875 7.875 14.7083L4.5 12.75C4.16667 12.5417 4 12.2083 4 11.875V7.95833C4 7.625 4.16667 7.29167 4.5 7.125L7.91667 5.125C8.25 4.95833 8.625 4.95833 8.91667 5.125L12.25 7.08333C12.5833 7.29167 12.75 7.625 12.75 7.95833V9.375L11.1667 10.2917V8.91667C11.1667 8.54167 10.9583 8.20833 10.6667 8.04167L8.875 6.95833C8.54167 6.79167 8.16667 6.79167 7.875 6.95833L6.08333 8C5.75 8.20833 5.58333 8.54167 5.58333 8.875V10.9583C5.58333 11.3333 5.79167 11.6667 6.08333 11.8333L7.875 12.9167C8.20833 13.0833 8.58333 13.0833 8.875 12.9167L11.1667 11.5417L12.75 10.6667L15.0833 9.29167Z",
    fill: "url(#paint0_linear_163_701)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_701",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5263B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B266F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonColor);
export default __webpack_public_path__ + "static/media/polygonColor.d7b8f3ae91725b1658810ef55dbac63f.svg";
export { ForwardRef as ReactComponent };